<template>
  <div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" :href="zroute('admin.dashboard')">
        <icon name="dashboard" class="mr-2 w-4 h-4" :class="zroute().current('admin.dashboard') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="zroute().current('admin.dashboard') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dashboard</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" :href="zroute('admin.corps')">
        <icon name="office" class="mr-2 w-4 h-4" :class="zroute().current('admin.corps') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="zroute().current('admin.corps') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Corps</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" :href="zroute('admin.users')">
        <icon name="users" class="mr-2 w-4 h-4" :class="zroute().current('admin.users') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="zroute().current('admin.users') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Users</div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
